import $ from 'jquery';
import * as CONST from '../../common/utils/constants';
import Util from '../../common/utils/ui';


class PlaybookDetail {
    constructor() {
        this.$navToggleSubmenu = $('.js-nav-toggle-submenu');
    }

    init() {
        this.bindEvents();
        window.addEventListener('scroll', this.stickyRelocate);
        window.addEventListener('scroll', this.triggerMobileNavBackground);
        this.setParentUrl();
    }
    
    bindEvents() {
        this.$navToggleSubmenu.on('click', e => { e.preventDefault(); this.mobileNavItem(e); });

        $('.js-subpages-pagebuilder .nav-link').on('click', (e) => {
            e.preventDefault();
            let target = e.currentTarget;
            const href = target.getAttribute('href');  
            this.opensubpage(href, target);
        });

        // jump to subpages if hash exists for one
        if (window.location.hash) {
            const subpageEl = $(`${window.location.hash}.subpage-pane`);
            if ($(subpageEl).length) {
                $(document).ready(() => {
                    let clickElement = null;
                    this.opensubpage(window.location.hash, clickElement, false);
                    //setTimeout used to override anchor link jump.
                     setTimeout(() => {
                        window.scrollTo(0, 0);
                    }, 1);
                });
            }
        } else {
            this.setActiveMenuItem();
        }
    }

    triggerMobileNavBackground() {
        // triggers background overlay for mobile nav
        if (Util.getViewPort() !== CONST.ViewPort.Desktop) {
            if ($('.js-nav-toggle-submenu').hasClass('open') && $('.js-nav-toggle-submenu').parent().hasClass('sticky')) {
                $('.mobile-overlay').show();
            } else {
                $('.mobile-overlay').hide();
            }
        }
    }

    setParentUrl() {
        //sets the URL for the see more plays btn on last page to the parent
        let url  = window.location.href;
        let str = `${url.substr(url.lastIndexOf('/') + 1)}$`;
        let parentUrl = url.replace(new RegExp(str), '');
        $('#seeMorePlays').attr('href', parentUrl);
    }

    stickyRelocate() {
        let windowTop = $(window).scrollTop();
        let footerTop = $('.footer').offset().top;
        let navOffset = $('.header').height();
        let divTop = $('#scroll-to-top').offset().top;
        let divHeight = $('.js-nav-toggle-submenu').height();
        
        if (windowTop + divHeight + navOffset > footerTop) {
            //sidenav hits footer and scrolls out of view
            $('.js-sub-navigation').removeClass('sticky');
            $('.js-nav-toggle-submenu').css('position', 'sticky');
            $('.js-nav-toggle-submenu').css('top', footerTop);
        }
        else if (windowTop + navOffset > divTop) {
            //sidenav stuck, scrolls with page
            $('.js-nav-toggle-submenu').css('top', $('.header').height() - 1);
            $('.js-nav-toggle-submenu').css('position', '');
            $('.js-sub-navigation').addClass('sticky');
        } else {
            //default, sidenav in original position
            $('.js-nav-toggle-submenu').css('top', '');
            $('.js-sub-navigation').removeClass('sticky');
        }
    }

    // clicking on items in mobile nav
	mobileNavItem(e) {
		if (Util.getViewPort() !== CONST.ViewPort.Desktop) {
			e.preventDefault();

			const target = $(e.currentTarget);
			const parent = target.find('ul');
			$(parent).slideToggle();
			$(parent).toggleClass('open');
            $(target).toggleClass('open');
            this.triggerMobileNavBackground();
		}
	}

    opensubpage(href, clickElement, enableScroll = true) {
        const subpage = $(`.js-subpages-pagebuilder .nav-subpages .nav-link${href}-subpage`);
        const parentSubpage = $(subpage).parent();
        const othersubpages = $('.js-subpages-pagebuilder .nav-subpages .nav-link').not($(subpage));
        const otherParents = $(othersubpages).parent();
        const pane = $(href);
        const otherPanes = $('.js-subpages-pagebuilder .subpage-pane').not(pane);
        $(othersubpages).removeClass('active'); //de-active other subpages
        $(subpage).addClass('active'); // activate subpage
        $(parentSubpage).addClass('active');
        this.setActiveArrowSize(parentSubpage);
        this.setActiveMenuItem($(subpage));
        $(otherPanes).removeClass('active').hide(); // hide other panes
        $(otherParents).removeClass('active');
        $(pane).addClass('active'); // display pane
        $(pane).show();
        $(subpage).focus();

        if (enableScroll) {
            this.scrollTopsubpages();
        }
        if (window.history.pushState) {
            window.history.pushState(null, null, href);
        }
        else {
            window.location.hash = href;
        }
    }
    
    setActiveArrowSize(parentSubpage) {
       let height = Math.ceil((parentSubpage.height() + 20) / 2);
        let arrow = parentSubpage.find('.arrow');
        $(arrow).css('border-top', `${height}px solid transparent`);
        $(arrow).css('border-bottom', `${height}px solid transparent`);
    }
    
    setActiveMenuItem(clickElement) {
        let value = $(clickElement).text();
        if (!value) {
            $('.current-subpage').first().text('Overview');
        } else {
            $('.current-subpage').first().text(value);
        }
    }

    scrollTopsubpages() {	
       let navOffset = $('.header').height();
       if (Util.getViewPort() !== CONST.ViewPort.Desktop) {
        $('html, body').animate({
            scrollTop: $('.play-info').offset().top - navOffset
        }, 1000);
        this.stickyRelocate();
        } else {
            $('html, body').animate({
                scrollTop: 0
            }, 1000);
        }
    }
}

export default PlaybookDetail;

$(() => {
    const playbookDetail = new PlaybookDetail();
    playbookDetail.init();
});